import * as Sentry from "@sentry/react";

export function initGlitchTip() {
  const dsn = import.meta.env.VITE_GLITCHTIP_DSN;

  if (!dsn) {
    console.warn("VITE_GLITCHTIP_DSN is not set. GlitchTip error tracking is disabled.");
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION || "unknown",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.5,
    normalizeDepth: 6,
    beforeSend(event, hint) {
      if (event.exception) {
        console.error("[GlitchTip]", hint.originalException || hint.syntheticException);
      }
      return event;
    },
  });
}

export { Sentry };
